import React from 'react';

const OngoingResearchProjects = () => {
  // Base styles for the component
  const styles = {
    container: {
      background: '#0a0a0a',
      padding: '4rem 2rem',
      fontFamily: 'Arial, sans-serif'
    },
    content: {
      maxWidth: '1400px',
      margin: '0 auto'
    },
    header: {
      textAlign: 'center',
      marginBottom: '4rem'
    },
    title: {
      fontSize: '3rem',
      fontWeight: 'bold',
      color: 'white',
      margin: '0 0 1.5rem 0'
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#9ca3af',
      lineHeight: '1.6',
      maxWidth: '800px',
      margin: '0 auto'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      gap: '2rem'
    },
    card: {
      background: 'rgba(20, 20, 20, 0.8)',
      border: '1px solid #2d2d2d',
      borderRadius: '16px',
      padding: '2rem',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    },
    statusContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem'
    },
    statusBadge: {
      padding: '0.5rem 1rem',
      borderRadius: '20px',
      fontSize: '0.875rem',
      fontWeight: '500',
      border: 'none',
      background: 'rgba(255, 255, 255, 0.1)',
      color: 'white'
    },
    percentage: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#60a5fa'
    },
    progressBarContainer: {
      width: '100%',
      height: '8px',
      background: '#374151',
      borderRadius: '4px',
      overflow: 'hidden',
      marginBottom: '2rem'
    },
    progressBar: (percentage) => ({
      height: '100%',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
      width: `${percentage}%`,
      transition: 'width 0.5s ease'
    }),
    projectTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: 'white',
      marginBottom: '2rem',
      lineHeight: '1.3'
    },
    details: {
      marginBottom: '2rem'
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1rem'
    },
    detailLabel: {
      color: '#9ca3af',
      fontSize: '1rem'
    },
    detailValue: {
      color: 'white',
      fontSize: '1rem',
      fontWeight: '500'
    },
    button: {
      width: '100%',
      padding: '1rem',
      background: 'transparent',
      border: '1px solid #374151',
      borderRadius: '8px',
      color: 'white',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  const projects = [
    { id: 1, status: 'In Progress', percentage: 85, title: 'AI Learning Assistant for Every Community' },
    { id: 2, status: 'Phase 2', percentage: 40, title: 'Cross-Platform AI Education Standardization' },
    { id: 3, status: 'Starting', percentage: 15, title: 'Multilingual AI Curriculum Development' }
  ];

  return (
    <div style={styles.container} data-component="container">
      <style>
        {`
          /* CSS Hover Effects */
          [data-component="card"]:hover {
            transform: translateY(-4px) !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
          }
          [data-component="button"]:hover {
            border-color: #4b5563 !important;
            background: rgba(75, 85, 99, 0.1) !important;
          }

          /* Responsive Styles */
          @media (max-width: 800px) {
            [data-component="grid"] {
              grid-template-columns: 1fr !important;
            }
            [data-component="card"] {
              width: 95% !important;
              margin: 0 auto !important;
            }
          }

          @media (max-width: 480px) {
            [data-component="container"] {
              padding: 3rem 1rem !important;
            }
            [data-component="title"] {
              font-size: 2.5rem !important;
            }
            [data-component="subtitle"] {
              font-size: 1.1rem !important;
            }
          }
        `}
      </style>
      <div style={styles.content}>
        <div style={styles.header}>
          <h2 style={styles.title} data-component="title">Ongoing Research Projects</h2>
          <p style={styles.subtitle} data-component="subtitle">
            Current initiatives driving innovation in AI education and technology advancement.
          </p>
        </div>

        <div style={styles.grid} data-component="grid">
          {projects.map((project) => (
            <div key={project.id} style={styles.card} data-component="card">
              <div style={styles.statusContainer}>
                <span style={styles.statusBadge}>{project.status}</span>
                <span style={styles.percentage}>{project.percentage}%</span>
              </div>

              <div style={styles.progressBarContainer}>
                <div style={styles.progressBar(project.percentage)} />
              </div>

              <h3 style={styles.projectTitle}>{project.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OngoingResearchProjects;